export default __webpack_public_path__ + "static/media/page1.e17d7b34.jpg";